import { CoasCarrousel } from "../components/coas_carrousel";
import { UHistoryCarrouselConfig } from "../utilities/carousel.utils";
class HistoryPage {
    constructor() {
        this.hitoryCarouselId = 'hitoryCarouselId';
        console.log("START HISTORY PAGE ....");
        this.initPageConfig();
    }
    initPageConfig() {
        // First landing carousel
        const contentHitoryCarousel = document.getElementById(this.hitoryCarouselId);
        if (contentHitoryCarousel) {
            const hitoryCarousel = new CoasCarrousel(this.hitoryCarouselId, UHistoryCarrouselConfig);
            hitoryCarousel.onInit();
        }
    }
}
window.addEventListener('load', function () {
    new HistoryPage();
});
